import Vue from 'vue'
import App from './App.vue'
// import 'lib-flexible'
import Notification from './components/notification'
import Router from 'vue-router'
import router from './router/index'
import VideoPlayer from 'vue-video-player/src'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)
Vue.use(Router)
Vue.config.productionTip = false
Vue.use(Notification)
new Vue({
    router,
    render: h => h(App),
}).$mount('#app')